// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers';
export class Meta {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsMeta(bb, obj) {
        return (obj || new Meta()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsMeta(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Meta()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    name(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    target(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return this.bb.__string(this.bb_pos + offset, optionalEncoding);
    }
    static startMeta(builder) {
        builder.startObject(2);
    }
    static addName(builder, nameOffset) {
        builder.addFieldOffset(0, nameOffset, 0);
    }
    static addTarget(builder, targetOffset) {
        builder.addFieldOffset(1, targetOffset, 0);
    }
    static endMeta(builder) {
        const offset = builder.endObject();
        builder.requiredField(offset, 4); // name
        builder.requiredField(offset, 6); // target
        return offset;
    }
    static createMeta(builder, nameOffset, targetOffset) {
        Meta.startMeta(builder);
        Meta.addName(builder, nameOffset);
        Meta.addTarget(builder, targetOffset);
        return Meta.endMeta(builder);
    }
}
//# sourceMappingURL=meta.js.map